import React from "react";
import { View } from '../../../components/templates/View';
import { CDCCTV, CMCCTV } from '../organisms';
import { useViewport } from "../../../hooks";

const CCTV = () => {

    const { width } = useViewport();

    return(
        width > 850 ?
            <>
                <View children={ <CDCCTV />} />
            </>
        :
            <>
                <View children={ <CMCCTV />} />
            </>
    );
}

export default CCTV;
